import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { Form, Input, message } from "antd";
import commonRules from "@/components/Pages/User/common/rules";
import Dynamic, { ExposeDynamicProps } from "@/components/App/Dynamic";
import Geetest from "components/Geetest";
import useNoEmailChange from "@/components/App/Dynamic/useNoEmailChange";
import SafeVerify, { FaCheckProps } from "@/components/App/SafeVerify/index";
import { axiosThrottle } from "@/utils/method";
import XtSvg from "components/Xt/Svg";
import NoEmail from "@/components/Xt/NoEmail";
import { waitRes } from "@/utils/axios";
import { getOrigin } from "@/utils/method";
import useNextTick from "@/hooks/useNextTick";
import { get_getFaCheckItem, post_updateBindEmail, post_bindEmail } from "@/api/uaapi/user";

interface EmailProps extends BaseCompProps {
  attr?: any;
}
interface FormDataProps extends ObjAny {
  email: string;
  emailCode: string;
  newEmailCode: string;
}
const { useTranslation } = Hooks;
const { useForm } = Form;
const initForm: FormDataProps = { email: "", newEmailCode: "", emailCode: "" };
let faResultId = '';
const Email: React.FC<EmailProps> = ({ className }) => {
  const t = useTranslation();
  const nextTick = useNextTick();
  const appEmailDynamicRef = useRef({} as ExposeDynamicProps);
  const { noEmailChange, noEmailVisible } = useNoEmailChange();
  const { emailAuth, email, getUserInfo } = store.user;
  const router = useRouter();
  const { isDark } = store.app;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initForm });
  const [refType, setRefType] = useState(0);
  const [puzzleValidate, setPuzzleValidate] = useState('');
  const [noEmailOpen, setNoEmailOpen] = useState(false);
  const [faBizType, setFaBizType] = useState(5);
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    email: '',
    countryCode: '',
    mobile: '',
    faItems: [],
  });
  useEffect(() => {
    getFaCheckItem();
  }, []);

  /**useEffect */
  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);
  const getUserInfoData = async () => await getUserInfo();


  const getFaCheckItem = async () => {
    const info = await getUserInfoData();
    let type = 5;
    if (!!info?.emailAuth) {
      type = 6;
      setFaBizType(type)
    }

    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType: type }
    });
    if (err) return

    faResultId = data.faCheckId;
    setFaCheckData(data)

    const newFormData = { ...formData };
    newFormData.email = '';
    type === 5 ? newFormData.emailCode = '' : newFormData.newEmailCode = '';
    setFormData(newFormData);
  };


  /**method */
  const onValuesChange = (changedValues: Partial<FormDataProps>) => {
    setFormData({ ...formData, ...changedValues });
  };
  const geetestRef = React.useRef<any>();
  const handleGeetestSuccess = async (puzzleValidateString) => {
    setPuzzleValidate(puzzleValidateString);
    if (refType == 1) {
      appEmailDynamicRef.current.handleClick(true, puzzleValidateString);

    }
    if (refType == 2) {
      appEmailDynamicRef.current.handleClick(true, puzzleValidateString);

    }
  };

  const submitForm = axiosThrottle(async (unlock, res) => {
    try {
      await formIns.validateFields();
      const { data, err } = await waitRes(emailAuth ? post_updateBindEmail : post_bindEmail, {
        errorPop: true,
        data: {
          faResultId: res.faResultId,
          email: formData.email,
          emailCode: formData.emailCode,
        },
      });
      unlock();
      if (err) return;
      if (!emailAuth)
        return message.success(t("account.bindEmailSuccess"), () => {
          router.push("/accounts/user/security-center");
        });
      message.success(t("account.updateBindEmailSuccess1"), async () => {
        store.user.resetStatusToNotLogin();
        await getUserInfo()
        router.push(`/accounts/login?backUrl=${encodeURIComponent(getOrigin() + "/" + router.locale + "/accounts/user/security-center")}`);
      });
    } catch (error) { }
  });
  return (
    <div className={cx(styles.email, className, isDark ? styles["email_dark"] : styles["email_light"])}>
      {/* 顶栏由 pages/accounts/user 的 backHeader 统一提供 */}
      <div className={styles["content"]}>
        <div className={styles["right_fa"]}>
          {/* 绑定/更改邮箱 */}
          <div className={styles["right_1"]}>
            <div className={styles["title"]}>{!emailAuth ? t("account.bindEmail") : t("account.modifyEmail")}</div>
            {emailAuth && (
              <div className={styles["tan"]}>
                <XtSvg src={require("@/assets/icon-svg/app/tan.svg")} />
                <div className={styles["text_tan"]}>{t("account.safeFund")}</div>
              </div>
            )}
            <div className={styles["tip"]}>
              <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
              <Form name="emailForm" form={formIns} onValuesChange={onValuesChange} layout="vertical">
                <div className={styles["email_text"]}>{!emailAuth ? t("account.emailVerify") : t("account.newEmailVerifyCode")}</div>
                <Form.Item label={!emailAuth ? t("account.email") : t("account.newEmail")} name="email" rules={commonRules.email}>
                  <Input className={styles["common_form_input"]} autoComplete="new-text" />
                </Form.Item>
                <Form.Item
                  label={!emailAuth ? t("account.EmailVerificationCode") : t("account.newEmailVerify")}
                  name="emailCode"
                  rules={commonRules.emailCode}
                >
                  <Input
                    className={styles["common_form_input"]}
                    allowClear
                    autoComplete="off"
                    maxLength={6}
                    suffix={
                      <div>
                        <Dynamic
                          ref={appEmailDynamicRef}
                          isNew={true}
                          FaValidTypeDict={'EMAIL'}
                          emailNew={formData.email}
                          faCheckId={faCheckData.faCheckId}
                          puzzleValidateString={puzzleValidate} msgType={2}
                           codeType={"USER_2006"}

                          noEmailChange={noEmailChange}
                          receiveAddress={formData.email}
                          onClick={() => {
                            nextTick(() => {
                              setRefType(2);
                              (geetestRef?.current as any).verify();
                            });
                          }}
                        />
                      </div>
                    }
                  />
                </Form.Item>
                {noEmailVisible && (
                  <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setNoEmailOpen(true)}>
                    {t("google.noEmail")}
                  </div>
                )}
              </Form>
              {/* 安全验证 */}
              {faCheckData.faItems.length > 0 && <div className={styles["email_text"]}>{t("app.2fa")}</div>}
              <SafeVerify faCheckData={faCheckData} showLink={true} faBizType={faBizType} dynamicCodeType={!emailAuth ? 'USER_2006' : 'USER_2007'} handleSuccessFn={submitForm} />
            </div>
          </div>
        </div>
      </div>
      <NoEmail open={noEmailOpen} changeOpen={() => setNoEmailOpen(false)} email={email} />
    </div>
  );
};
export default observer(Email);
